/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Clear_All_LabelInputs */



/**
* | output |
* | --- |
* | "Clear all segments" |
*
* @param {Segment_Event_Group_Clear_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_clear_all_label = /** @type {((inputs?: Segment_Event_Group_Clear_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Clear_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer tous les segments")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Segmente löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella tutti i segmenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить все сегменты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar todos los segmentos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除所有段")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのセグメントをクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी खंडों को साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar todos os segmentos")
	return /** @type {LocalizedString} */ ("Clear all segments")
});